<template>
	<div class="paramset" ref="paramset">
		<div v-show="paramlist.length==0" style="text-align: center;font-size: 10pt;">无口岸参数可设置</div>
		<ul class="clear_ul" v-show="paramlist.length>0">
			<li :class="i.u_enabled=='True'?'lieabled':'lidisabled'" v-for="i in paramlist"> 
				<span>{{i.p_mode}}</span>
				<div>
					<el-button size="mini" round type="warning" v-if="i.u_enabled=='True'" @click="setparamenabled(0,i.p_mode)">停用</el-button>
					<el-button size="mini" round type="warning" v-if="i.u_enabled=='False'" @click="setparamenabled(1,i.p_mode)">启用</el-button>
					<el-button size="mini" round type="success" v-if="type=='0'" @click="setparam(i.p_mode)">设置</el-button>
				</div>
			</li>
		</ul>
		<el-dialog :title="settitle" :visible.sync="showset" width="680px" append-to-body :close-on-click-modal="false" :show-close="false">
			<paramset_pmode ref="paramset_pmode" :pmode="currentp_mode"></paramset_pmode>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import paramset_pmode from './paramset_pmode.vue'
export default {
	components: {
		paramset_pmode
	},
	props: {
		//列表数据
		paramtype: {
			type: String,
			default:'0'
		}
	},
	data() {
		return {
			paramlist:[],
			showset:false,
			settitle:'',
			type:0,
			currentp_mode:''//当前选中的口岸
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/wm/paramset.scss');
		});
		var that=this;
		Utils.$on('dialogclose', function(msg) {
			that.dialogclose(msg);
		});
		this.type=this.paramtype;
		this.init();
	},
	methods:{
		init(param){
			if(param!=undefined)
				this.type=param.type; //操作类型  0--设置出库参数  1--设置拆单参数 2--设置分单参数
			if(this.type==-1){
				
			}
			this.$tool.loading('正在加载', 'paramset');
			//获取渠道
			var that=this;
			this.$apipost.get.GetStoragePmode().then(res => {
				this.$tool.loadingclose();
				if(res.state=="1"){
					that.paramlist=res.data;
				}
			});
		},
		//启用或者停用渠道
		setparamenabled(isenabled,p_mode){
			var that=this;
			this.$apipost.post.SetClearisEnabled({isenabled:isenabled,p_mode:p_mode}).then(res => {
				if(res.state=="1"){
					this.$tool.message('设置成功', 1);
					var list=that.paramlist;
					for(var i=0;i<list.length;i++){
						if(list[i].p_mode==p_mode){
							if(isenabled==1){
								list[i].u_enabled='True';
							}else{
								list[i].u_enabled='False';
							}
							break;
						}
					}
					that.paramlist=list;
				}else{
					this.$tool.message('设置失败', 0);
				}
			});
		},
		//打开设置参数窗口
		setparam(p_mode){
			this.showset=true;
			this.settitle=p_mode+'参数';
			this.currentp_mode=p_mode;
			if(this.$refs.paramset_pmode!=undefined)
				this.$refs.paramset_pmode.init({p_mode:this.currentp_mode});
		},
		dialogclose(close){
			if(close=="1")
				this.showset=true;
			else
				this.showset=false;
		}
	}
};
</script>